import * as API from "../api";
import AppState from '../state/AppState';

export const getMyUser = () => {
  return API.getMyUser()
    .then((result) => {
      AppState.setUser(result.user);
    });
};

export const getAllUserData = () => {
  return API.getMyUser({withorgs: 1, includesettings: 1, checkpremium: 1})
    .then((result) => {
      AppState.setUser(result.user);
      AppState.setUserSettings(result.user.settings);
    });
};


export const updateUser = (first, last, email) => {
  return API.updateUser(first, last, email)
    .then(() => getMyUser());
};

export const purchasePremium = (token) => {
  return API.purchasePremium(token)
    .then((result) => {
      // AppState.setPaymentMethod(result.source);
      // AppState.setCharges(result.charges);
      // AppState.setNextInvoice(result.nextInvoice);
      // AppState.setSubscription(result.subscription);
    });
};

export const purchaseTeam = (name, addlseats, token) => {
  return API.purchaseTeam(name, addlseats, token)
    .then((result) => {
      // AppState.setPaymentMethod(result.source);
      // AppState.setCharges(result.charges);
      // AppState.setNextInvoice(result.nextInvoice);
      // AppState.setSubscription(result.subscription);
    });
};

export const getOrgs = () => {
  return API.getOrgs()
    .then((result) => {
      AppState.setOrgs(result.orgs.items);
    });
};

export const getSubscription = () => {
  return API.getSubscription()
    .then((result) => {
      AppState.setSubscription(result.subscription);
    });
};

export const cancelSubscription = () => {
  return API.cancelSubscription(AppState.state.subscription.id)
    .then(() => getSubscription())

};

export const renewSubscription = () => {
  return API.renewSubscription(AppState.state.subscription.id)
    .then(() => getSubscription())
};

export const getPaymentMethod = () => {
  return API.getPaymentMethod()
    .then((result) => AppState.setPaymentMethod(result.source))
};

export const updatePaymentMethod = (token) => {
  return API.updatePaymentMethod(token)
    .then((result) => getPaymentMethod())
};

export const getCharges = () => {
  return API.getCharges()
    .then((result) => {
      AppState.setCharges(result.charges);
    });
};

export const getNextInvoice = () => {
  return API.getNextInvoice()
    .then((result) => {
      AppState.setNextInvoice(result.invoice);
    });
};



// WEBPACK FOOTER //
// ./src/actions/UserActions.js